import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CircuitBulbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-bulb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M2 12h5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 12h5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M8.5 8.5l7 7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M15.5 8.5l-7 7"
    }, null), _createTextVNode(" ")]);
  }
};